import { defineMessages } from "react-intl";
import {
	diseasesMessages,
	validator
} from "lib/build/forms/ltx/phase-i/medical-history/comorbidities/respiratoryAndPulmonaryDiseases";
import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	respiratoryAndPulmonaryDiseases: {
		id: "form.respiratory_and_pulmonary_diseases",
		defaultMessage: "Légúti és tüdőbetegségek"
	},
	diseases: {
		id: "form.respiratory_and_pulmonary_diseases.diseases",
		defaultMessage: "Betegség"
	},
	comment: {
		id: "form.respiratory_and_pulmonary_diseases.comment",
		defaultMessage: "Megjegyzés"
	}
});

const fields: { [key: string]: FieldData } = {
	diseases: {
		type: "field",
		path: ["diseases"],
		label: messages.diseases,
		errorMessages: genericErrorMessages,
		input: { type: "select", props: { labels: diseasesMessages } }
	},
	comment: {
		type: "field",
		path: ["comment"],
		label: messages.comment,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.diseases }] },
		{ columns: [{ width: 12, field: fields.comment }] }
	]
};

export const node: LeafNode = {
	id: "respiratoryAndPulmonaryDiseases",
	value: {
		title: messages.respiratoryAndPulmonaryDiseases,
		validator,
		fieldset,
		applyCurrentDate: true
	}
};
